export default __webpack_public_path__ + "static/media/chest1.e6d94838.svg";